import { useEffect, useState } from 'react';

import { fetchHealth, HealthResponse } from '../services/health';

export function useHealthCheck(pollIntervalMs: number = 30000) {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadHealth = async () => {
      try {
        const data = await fetchHealth();
        setHealth(data);
      } catch {
        // Silently fail; don't break the app if health check fails
        setHealth(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadHealth();
    const interval = setInterval(loadHealth, pollIntervalMs);
    return () => clearInterval(interval);
  }, [pollIntervalMs]);

  return { health, isLoading };
}
